import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Resources from './pages/Resources';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ai" element={<Resources />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
